import {ElementRef, EventEmitter, Injectable, NgZone} from '@angular/core';
import { WindowService } from '../services/window/window.service';
import { ShifuInitParameters } from '../shared/models/shifu-init-parameters';

declare var ShifuConfig:any;

export enum ScreenType {
    MOBILE = <any> "MOBILE"
    , TABLET = <any> "TABLET"
    , DESKTOP = <any> "DESKTOP"
}

export enum DesktopType {
    SMALL = <any> "SMALL"
    , BIG = <any> "BIG"
}

export class ScreenConfig {
    type: ScreenType;
    desktopType?: DesktopType;
    width: number;
    heigth: number;
}

class ViewportData {
    elementRef: ElementRef;
    viewed: boolean;
    resolveFunction: Function;
}

@Injectable()
export class Utils {
    screenConfig: ScreenConfig;
    screenChange: EventEmitter<any> = new EventEmitter();

    private _viewportDatas: ViewportData[] = [];

    constructor(private windowService: WindowService,private _zone: NgZone) {
        this.screenConfig = {type: null, width: null, heigth: null};
        this._calculateScreen();

        this._zone.runOutsideAngular(() => {
            if (typeof this.windowService.nativeWindow !== 'undefined') {
                this.windowService.nativeWindow.addEventListener("resize", (() => {
                    this._zone.run(() => {
                        this._calculateScreen();
                        this.screenChange.emit({});
                    });
                }));

                this.windowService.nativeWindow.addEventListener("scroll",(() => {
                    if (this._viewportDatas != null) {
                        for (let i = 0; i < this._viewportDatas.length; i++) {
                            let viewportData: ViewportData = this._viewportDatas[i];
                            if (!viewportData.viewed && this._elementIsInViewport(viewportData.elementRef)) {
                                this._zone.run(() => {
                                    viewportData.viewed = true;
                                    viewportData.resolveFunction();
                                });
                            }
                        }
                    }
                }));
            }
        });
    }

    private _elementIsInViewport(elementRef: ElementRef) {
        let clientRect: ClientRect = elementRef.nativeElement.getBoundingClientRect();

        return (
            clientRect.top >= 0 &&
            clientRect.left >= 0 &&
            clientRect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            clientRect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    public attributeExist(object, key) {
        if(object && key === '') return false;
        if(!object) return false;
        return key.split(".").reduce(function(firstElement, secondElement) {
            return (!firstElement) ? firstElement : firstElement[secondElement];
        }, object) !== undefined;
    }

    elementInViewport(elementRef: ElementRef) {
        return new Promise((resolve, reject) => {
            this._viewportDatas.push({elementRef: elementRef, viewed: false, resolveFunction: resolve});
        });
    }

    private _isVisible(elementId: string) {
        return this.windowService.nativeWindow.getComputedStyle(document.getElementById(elementId)).display != "none";
    }

    private _calculateScreen() {
        this.screenConfig.width = Math.max(document.documentElement.clientWidth, this.windowService.nativeWindow.innerWidth || 0);
        this.screenConfig.heigth = Math.max(document.documentElement.clientHeight, this.windowService.nativeWindow.innerHeight || 0);
        this.screenConfig.type = this._getScreenType();
        this.screenConfig.desktopType = this._getDesktopType();
    }

    private _getScreenType(): ScreenType {
        let screenType: ScreenType = null;

        if (this._isVisible("transfers-mobile-size")) {
            screenType = ScreenType.MOBILE;

        } else if (this._isVisible("transfers-tablet-size")) {
            screenType = ScreenType.TABLET;

        } else {
            screenType = ScreenType.DESKTOP;
        }

        return screenType;
    }

    private _getDesktopType(): DesktopType {
        let desktopType: DesktopType = null;

        if (this._isVisible("transfers-desktop-size")) {
            desktopType = DesktopType.SMALL;

        } else if (this._isVisible("transfers-bigdesktop-size")) {
            desktopType = DesktopType.BIG;
        }

        return desktopType;
    }

    public static getActualCookiesAsObject(): Object {
        let result: Object = {};
        if (document.cookie != null && document.cookie.length > 0) {
            document.cookie.split(';').forEach((cookie: string) => {
                if (cookie.includes('=')) {
                    const cookieValueAsArray: Array<string> = cookie.split('=');
                    let cookieName: string = '';
                    let cookieValue: string = '';
                    if (cookieValueAsArray.length == 2) {
                        cookieName = cookieValueAsArray[0];
                        cookieValue = decodeURIComponent(cookieValueAsArray[1]);
                        if (cookieValue.includes('{') && cookieValue.includes('}')) {
                            try {
                                cookieValue = JSON.parse('{' + cookieValue.replace(/\\"/g, '"').split('{')[1].split('}')[0] + '}');
                            } catch (error) {
                                cookieValue = '';
                                cookieName = '';
                            }
                        }
                        if (cookieName.length > 0 && (
                            typeof cookieValue === 'string' && cookieValue.length > 0 ||
                            typeof cookieValue === 'object' && cookieValue != null
                        )) {
                            result[cookieName] = cookieValue;
                        }
                    }
                }
            });
        }
        return Utils.removeDuplicatedKeys(result);
    }

    public static removeDuplicatedKeys(object: Object): Object {
        let result: Object = {};
        Object.keys(object).forEach((key: string) => {
            if (typeof object[key] === 'object') {
                const value: Object = object[key];
                result[key.replace(/\s/g, '')] = JSON.stringify(value);
            } else {
                const value: string = object[key];
                if (value != null) {
                    result[key.replace(/\s/g, '')] = value;
                }
            }
        });
        return result;
    }

    static init(shifuInitParameters:ShifuInitParameters):void{
        ShifuConfig.init(shifuInitParameters);
      }

}
